import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const ChatFilled: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 19 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.03992 2.71434C0.555473 3.64708 0.555473 4.86812 0.555473 7.31019V8.34291C0.555473 9.81604 0.555473 10.5525 0.735027 11.1534C1.16098 12.5785 2.29681 13.6928 3.74934 14.1107C4.36178 14.2869 5.11245 14.2869 6.61396 14.2869H7.10178L7.15965 14.287C8.0665 14.2926 8.94996 14.5704 9.6913 15.0829L9.73841 15.1159L12.059 16.7422C12.8546 17.2996 13.9 16.4945 13.5369 15.604C13.2797 14.9731 13.7532 14.2869 14.4458 14.2869H14.9807C16.8322 14.2869 18.3333 12.8143 18.3333 10.9976V7.31019C18.3333 4.86812 18.3333 3.64708 17.8488 2.71434C17.4227 1.89387 16.7428 1.2268 15.9065 0.808757C14.9558 0.333496 13.7113 0.333496 11.2221 0.333496H7.66658C5.17743 0.333496 3.93289 0.333496 2.98214 0.808757C2.14587 1.2268 1.46596 1.89387 1.03992 2.71434ZM12.9999 4.91195C13.3681 4.91195 13.6666 5.20479 13.6666 5.56601C13.6666 5.92724 13.3681 6.22008 12.9999 6.22008H9.44436C9.07618 6.22008 8.7777 5.92724 8.7777 5.56601C8.7777 5.20479 9.07618 4.91195 9.44436 4.91195H12.9999ZM12.9999 8.4003C13.3681 8.4003 13.6666 8.69314 13.6666 9.05436C13.6666 9.41558 13.3681 9.70843 12.9999 9.70843H5.88881C5.52063 9.70843 5.22214 9.41558 5.22214 9.05436C5.22214 8.69314 5.52063 8.4003 5.88881 8.4003H12.9999Z"
        fill="currentColor"
      />
    </svg>
  )
})

ChatFilled.displayName = 'ChatFilled'
